import type { MarketingRepository } from '../application/MarketingRepository'
import type { MarketingConnection, MarketingStatus } from '../domain/marketing'

/**
 * Sans Supabase (développement local, captures) : les trois sources existent mais n'ont jamais été synchronisées.
 * Aucun chiffre n'est fabriqué, même ici : l'écran montre l'état « première synchronisation ». Les tests
 * automatisés fournissent leurs propres données par un dépôt simulé.
 */
const connection = (source: MarketingConnection['source'], accountId: string): MarketingConnection => ({
  source,
  provider: 'WINDSOR',
  accountId,
  accountLabel: null,
  status: 'NOT_SYNCED',
  lastAttemptAt: null,
  lastSuccessAt: null,
  lastErrorCode: null,
  lastErrorMessage: null,
  dataUntil: null,
  running: false,
})

const status: MarketingStatus = {
  connections: [
    connection('GOOGLE_ADS', '409-040-8544'),
    connection('GA4', '555601743'),
    connection('SEARCH_CONSOLE', 'groupereca.com'),
  ],
  runs: [],
}

const unavailable = () => Promise.reject(new Error('MARKETING_NOT_SYNCED'))

export function createFixtureMarketingRepository(): MarketingRepository {
  return {
    getStatus: () => Promise.resolve(status),
    getOverview: unavailable,
    getAdsBreakdown: unavailable,
    getGa4Breakdown: unavailable,
    getGscBreakdown: unavailable,
    sync: () => Promise.reject(new Error('PROVIDER_NOT_CONFIGURED')),
    testConnections: () => Promise.reject(new Error('PROVIDER_NOT_CONFIGURED')),
  }
}
